import TitleText from './TitleText';

export default TitleText;
